/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcademicTimeLineProjection } from '../models/AcademicTimeLineProjection';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AcademicTimelineRestControllerService {
  /**
   * getAcademicTimeline
   * @returns AcademicTimeLineProjection OK
   * @throws ApiError
   */
  public static getAcademicTimelineUsingGet({
    studentId,
  }: {
    /**
     * studentId
     */
    studentId: string;
  }): CancelablePromise<Array<AcademicTimeLineProjection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/academic-timeline/{studentId}',
      path: {
        studentId: studentId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
